@import 'styles/mixins';
@import 'styles/variables';

.TableSizeSelector {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 9px 12px;

  .rowContainer {
    display: flex;
    gap: 4px;

    .tableSizeButton {
      width: 21px;
      height: 21px;
      border-radius: 1px;
      background: $white;
      border: 1px solid $grey-10;
      cursor: pointer;
    }

    .tableSizeButton__active {
      @extend .tableSizeButton;
      background: $grey-5;
    }
  }
}
